// Publiek buitenscherm aan de ingang: vrije plaatsen in 25 talen, verversing elke 30 s.
export const WELCOME = [
  "Welkom", "Welcome", "Bienvenue", "Willkommen", "Bienvenido", "Benvenuti", "Bem-vindo",
  "Velkommen", "Välkommen", "Tervetuloa", "Velkommen", "Witamy", "Vítejte", "Vitajte",
  "Üdvözöljük", "Bine ați venit", "Добре дошли", "Dobrodošli", "Dobrodošli", "Laipni lūdzam",
  "Sveiki atvykę", "Tere tulemast", "Καλώς ορίσατε", "Merħba", "Fáilte",
];

export const FREE_PITCHES = [
  "vrije plaatsen", "free pitches", "emplacements libres", "freie Plätze", "parcelas libres",
  "piazzole libere", "lugares livres", "frie pladser", "lediga platser", "vapaita paikkoja",
  "ledige plasser", "wolne miejsca", "volná místa", "voľné miesta", "szabad helyek",
  "locuri libere", "свободни места", "prosta mesta", "slobodna mjesta", "brīvas vietas",
  "laisvos vietos", "vabad kohad", "ελεύθερες θέσεις", "postijiet liberi", "láithreáin saor",
];

export const RECEPTION = [
  "Receptie", "Reception", "Réception", "Rezeption", "Recepción", "Ricevimento", "Receção",
  "Reception", "Reception", "Vastaanotto", "Resepsjon", "Recepcja", "Recepce", "Recepcia",
  "Recepció", "Recepție", "Рецепция", "Recepcija", "Recepcija", "Reģistratūra",
  "Registratūra", "Vastuvõtt", "Υποδοχή", "Reċeption", "Fáiltiú",
];

export const CLOSED = [
  "Gesloten", "Closed", "Fermé", "Geschlossen", "Cerrado", "Chiuso", "Fechado",
  "Lukket", "Stängt", "Suljettu", "Stengt", "Zamknięte", "Zavřeno", "Zatvorené",
  "Zárva", "Închis", "Затворено", "Zaprto", "Zatvoreno", "Slēgts",
  "Uždaryta", "Suletud", "Κλειστά", "Magħluq", "Dúnta",
];

export const FULL = [
  "VOLZET", "FULLY BOOKED", "COMPLET", "AUSGEBUCHT", "COMPLETO", "AL COMPLETO", "LOTAÇÃO ESGOTADA",
  "FULDT BOOKET", "FULLBOKAT", "TÄYNNÄ", "FULLBOOKET", "BRAK MIEJSC", "OBSAZENO", "OBSADENÉ",
  "MEGTELT", "COMPLET OCUPAT", "НЯМА СВОБОДНИ МЕСТА", "ZASEDENO", "POPUNJENO", "VIETU NAV",
  "VIETŲ NĖRA", "TÄIS", "ΠΛΗΡΕΣ", "MIMLI", "LÁN",
];
